import React from 'react'
import WarehouseEdit from "./WarehouseEdit";
import WarehouseDelete from "./WarehouseDelete";

const WarehouseActions = ({record, updater}) => {

    return(
        <React.Fragment>
            <WarehouseEdit  warehouse={record} updater={updater} />
            <WarehouseDelete warehouse={record} updater={updater} />
        </React.Fragment>
    )
}
export default WarehouseActions